<template>
    <div class="poster">
        <div class="title">
            <p>快速预警</p>
        </div>
        <div class="main">
            <div class="form">
                <el-form :inline="true" :model="formInline" class="demo-form-inline">
                    <el-form-item>
                        <el-input v-model="formInline.name" placeholder="请输入快速预警" clearable></el-input>
                    </el-form-item>
                    <el-form-item style="float: right">
                        <el-button type="primary" @click="onSubmit">查 询</el-button>
                        <el-button @click="reset">重 置</el-button>
                    </el-form-item>
                </el-form>
            </div>
        </div>
        <div class="main table">
            <div class="tabs">
                <el-tabs v-model="activeName">
                    <el-tab-pane label="快速预警" name="0"></el-tab-pane>
                </el-tabs>
                <div class="btnlist">
                    <el-button class="btn" type="primary" size="medium" @click="selectProduct('create')">+ 添加</el-button>
                </div>
            </div>
            <div class="table">
                <el-table ref="table" :data="tableData" style="width: 100%" v-loading="tabload">
                    <el-table-column prop="name" label="产品名称" align="center" show-overflow-tooltip> </el-table-column>
                    <el-table-column prop="sale_price" label="销售价(元)" align="center"> </el-table-column>
                    <el-table-column prop="price_top" label="价格上限(元)" align="center"> </el-table-column>
                    <el-table-column prop="price_bottom" label="价格下限(元)" align="center"> </el-table-column>
                    <el-table-column prop="opt" label="操作" align="center" fixed="right">
                        <template slot-scope="scope">
                            <div class="link">
                                <el-link v-show="scope.row.status != 3 && scope.row.status != 2" type="primary" @click="selectProduct('edit', scope.row)">编辑</el-link>
                                <el-link type="primary" @click="selectProduct('detail', scope.row)">详情</el-link>
                                <el-link type="primary" @click="selectProduct('delete', scope.row)">删除</el-link>
                            </div>
                        </template>
                    </el-table-column>
                </el-table>
            </div>
            <div class="pageList">
                <el-pagination
                    @size-change="handleSizeChange"
                    @current-change="handleCurrentChange"
                    :current-page="page"
                    :page-sizes="[10, 20, 30, 40]"
                    :page-size="size"
                    layout="total, sizes, prev, pager, next, jumper"
                    :total="total"
                    background
                >
                </el-pagination>
            </div>
        </div>
        <Detail ref="refDetail"></Detail>
        <CreateOrEdit ref="refCreateOrEdit" @init="getList(1)"></CreateOrEdit>
    </div>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import CreateOrEdit from "@/components/Modules/QuickWarn/CreateOrEdit.vue";
import Detail from "@/components/Modules/QuickWarn/Detail.vue";
export default {
    components: {
        Detail,
        CreateOrEdit,
    },
    data() {
        return {
            activeName: "0",
            tabload: false,
            page: 1,
            size: 10,
            total: 0,
            tableData: [],
            formInline: {
                name: "", //经销商名称，非必填
            },
        };
    },
    computed: {
        ...mapGetters(["getToken"]),
    },
    created() {
        this.getList(1);
    },
    methods: {
        ...mapActions({
            getQuickList: "brand/getQuickList", //经销商列表
            deleteQuick: "brand/deleteQuick",
        }),

        // 操作
        selectProduct(type, row) {
            if (type == "edit") {
                this.$refs.refCreateOrEdit.editId = row.id;
                this.$refs.refCreateOrEdit.dialogVisible = true;
                this.$refs.refCreateOrEdit.getDetail(row);
            } else if (type == "detail") {
                this.$refs.refDetail.dialogVisible = true;
                this.$refs.refDetail.getDetail(row);
            } else if (type == "create") {
                this.$refs.refCreateOrEdit.dialogVisible = true;
            } else if ((type = "delete")) {
                this.deleteQuickFunc(row.id);
            }
        },
        deleteQuickFunc(id) {
            this.$confirm("此操作将永久删除该数据, 是否继续?", "提示", {
                confirmButtonText: "确定",
                cancelButtonText: "取消",
                type: "warning",
            })
                .then(() => {
                    let params = {
                        token: this.getToken,
                        id,
                    };
                    this.deleteQuick(params).then(({ data }) => {
                        if (data.code == 1) {
                            this.$message.success("删除成功！");
                            this.getList();
                        } else {
                            this.$message.error(data.msg);
                        }
                    });
                })
                .catch(() => {
                    this.$message({
                        type: "info",
                        message: "已取消删除",
                    });
                });
        },
        // 快速預警
        getList(tag) {
            this.tabload = true;
            let opt = {
                token: this.getToken,
                name: this.formInline.name, //经销商名称，非必填
                size: this.size, //页大小
                page: tag == 1 ? tag : this.page, //页数
            };
            this.getQuickList(opt).then(({ data }) => {
                this.tabload = false;
                if (data.code == 1) {
                    this.tableData = data.data.list;
                    this.total = data.data.count ? data.data.count : 0;
                } else {
                    this.$message.error(data.msg);
                }
            });
        },
        // 分页
        handleSizeChange(val) {
            this.size = val;
            this.getList();
        },
        // 分页
        handleCurrentChange(val) {
            this.page = val;
            this.getList();
        },
        // 搜索
        onSubmit() {
            this.getList(1);
        },
        // 重置
        reset() {
            this.formInline = {
                name: "", //经销商名称，非必填
            };
            this.getList(1);
        },
    },
};
</script>
<style lang="scss" scoped>
.poster {
    position: relative;
    height: 100%;
    .table {
        padding: 20px;
    }
    ::v-deep .el-tabs__active-bar {
        width: 120px;
    }

    ::v-deep .el-tabs__item {
        width: 120px;
        text-align: center;
        padding: 0;
    }

    .title {
        box-shadow: 0px 0px 8px 0px rgb(100 100 100 / 17%);
        width: 100%;
        background: #fff;
        padding: 15px 32px;
        display: flex;
        align-items: center;

        p {
            font-size: 16px;
            color: #333;
            margin-left: 32px;

            span {
                color: #e72f0d;
                padding: 0 5px;
            }

            &:first-child {
                font-size: 18px;
                color: #333;
                margin-left: 0;
            }

            &:nth-child(2) {
                span {
                    color: #2448ff;
                }
            }
        }
    }
    .main.table {
        min-width: 1200px;
        min-height: 600px;
        .table {
            min-height: 500px;
        }
    }
    .main {
        min-width: 1200px;
        box-shadow: 0px 0px 8px 0px rgba(100, 100, 100, 0.17);
        background: #fff;
        margin: 24px;
        padding: 24px;
        ::v-deep .el-form-item {
            margin-bottom: 0;
        }
        .tabs {
            position: relative;
        }
        .btnlist {
            position: absolute;
            right: 0;
            bottom: 28px;
            display: flex;
            .btn {
                margin-left: 10px;
            }
        }
        span {
            margin-right: 10px;

            ::v-deep .el-input {
                width: 150px;
                display: inline-block;
            }
        }

        ::v-deep .el-table th {
            background: #fafafa;
            padding: 10px 0;
        }
    }
}
.pageList {
    text-align: right;
    margin-top: 20px;
}
.link {
    a {
        margin: 0 12px;
    }
}
.red {
    color: red;
}
.orange {
    color: orange;
}
</style>